import paths from "../../../routes/paths";
import { uploadFileToS3, BUCKET_NAME } from "../../../utils/uploadFileToS3";

const getFileExtension = (file) => {
  if (!file || typeof file === "string") return "";

  if (file.name) {
    const match = file.name.match(/\.([a-zA-Z0-9]+)$/);
    if (match) return `.${match[1].toLowerCase()}`;
  }

  const mimeToExt = {
    "image/jpeg": ".jpg",
    "image/png": ".png",
    "image/webp": ".webp",
    "image/gif": ".gif",
    "application/pdf": ".pdf",
  };

  return mimeToExt[file.type] || "";
};

const uploadIfFile = async (file, key) => {
  if (!file) return null;
  if (typeof file === "string") return file;

  const ext = getFileExtension(file);
  const res = await uploadFileToS3(BUCKET_NAME, file, `${key}${ext}`);
  return res.s3Url;
};

export const uploadCibilDocuments = async (cibilCheck, leadId) => {
  const timestamp = Date.now();

  const [
    aadhaarFrontUrl,
    aadhaarBackUrl,
    panCardUrl,
    rcFrontUrl,
    rcBackUrl,
    addressProofUrl,
  ] = await Promise.all([
    uploadIfFile(cibilCheck.aadhaarFrontUrl, `aadhaar-front-${timestamp}`),
    uploadIfFile(cibilCheck.aadhaarBackUrl, `aadhaar-back-${timestamp}`),
    uploadIfFile(cibilCheck.panCardUrl, `pan-card-${timestamp}`),
    uploadIfFile(cibilCheck.rcFrontUrl, `rc-front-${timestamp}`),
    uploadIfFile(cibilCheck.rcBackUrl, `rc-back-${timestamp}`),
    uploadIfFile(cibilCheck.addressProofUrl, `address-proof-${timestamp}`),
  ]);

  return {
    aadhaarFrontUrl,
    aadhaarBackUrl,
    panCardUrl,
    rcFrontUrl,
    rcBackUrl,
    addressProofUrl,
    cibilNumber: cibilCheck.cibilNumber,
  };
};

export const uploadCrifReport = async (crifReportUrl, leadId) => {
  const timestamp = Date.now();

  const crifReportUrlRes = await uploadIfFile(
    crifReportUrl,
    `crif-report-${timestamp}`,
  );

  return {
    crifReportUrl: crifReportUrlRes,
  };
};
